/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteServiceProviderOrganizations } from '../fn/service-provider/delete-service-provider-organizations';
import { DeleteServiceProviderOrganizations$Params } from '../fn/service-provider/delete-service-provider-organizations';

@Injectable({ providedIn: 'root' })
export class ServiceProviderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteServiceProviderOrganizations()` */
  static readonly DeleteServiceProviderOrganizationsPath = '/service-provider/organizations/{organizationKey}';

  /**
   * delete a organization.
   *
   * Delete a organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteServiceProviderOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations$Response(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteServiceProviderOrganizations(this.http, this.rootUrl, params, context);
  }

  /**
   * delete a organization.
   *
   * Delete a organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteServiceProviderOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<void> {
    return this.deleteServiceProviderOrganizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
